import _, { compose, partial } from 'underscore';
import { withProps } from '@bingads-webui-react/with-props';
import { withControlErrorHandling, withUnvalidatedControlErrors } from '@bingads-webui-campaign-react/error-handling';
import { propertyIs, StandardControlAdapter, orComp, codeIs } from '@bingads-webui-campaign-react/form-error';
import { ValidatedUrlOptionsParameters, ValidatedUrlOptionsParametersWithError } from '@bingads-webui-campaign-react/url-options';

const campaignTrackingUrlTemplate = orComp(
  propertyIs('TrackingUrlTemplate'),
  orComp(
    codeIs('InvalidAppId'),
    codeIs('InvalidQueryDelimiterPlacement')
  )
);
const campaignFinalUrlSuffix = propertyIs('FinalUrlSuffix');
const campaignUrlCustomParameters = propertyIs('UrlCustomParameters');
const trackingUrlTemplateControlsWrapper = compose(
  withControlErrorHandling,
  partial(withUnvalidatedControlErrors, _, { filter: campaignTrackingUrlTemplate, Adapter: StandardControlAdapter() })
);
const finalUrlSuffixControlsWrapper = compose(
  withControlErrorHandling,
  partial(withUnvalidatedControlErrors, _, { filter: campaignFinalUrlSuffix, Adapter: StandardControlAdapter() })
);
const urlCustomParametersControlsWrapper = compose(
  withControlErrorHandling,
  partial(withUnvalidatedControlErrors, _, { filter: campaignUrlCustomParameters, Adapter: StandardControlAdapter({ functionsToInject: ['onCustomParameterKeyChange', 'onCustomParameterValueChange', 'onRemoveUrlParameter', 'onAddUrlParameter'] }) })
);

export const ValidatedUrlOptionsParameter = withControlErrorHandling(withProps({
  trackingUrlTemplateControlsWrapper,
  finalUrlSuffixControlsWrapper,
  urlCustomParametersControlsWrapper,
}, ValidatedUrlOptionsParameters));

export const ValidatedUrlOptionsParameterWithError = withControlErrorHandling(withProps({
  trackingUrlTemplateControlsWrapper,
  finalUrlSuffixControlsWrapper,
  urlCustomParametersControlsWrapper,
}, ValidatedUrlOptionsParametersWithError));
